export default {
  header: {
    title: 'Usa i tuoi punti',
    balance: '{{value}} pt disponibili',
  },
  option_label: '{{value}} pt',
  buttons: {
    none: 'Nessuno',
  },
  toasts: {
    enabled: 'Punti fedeltà applicati con successo',
    removed: 'Punti fedeltà rimossi',
  },
};
